module.exports = __webpack_public_path__ + "static/media/year2020_11-sc.2a7f7a09.jpg";